export default __webpack_public_path__ + "static/media/Interior-(4).ac4bd556.jpg";